import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { CheckLaborerSurveyEligibilityResponse } from 'api/laborerPortalAPI/authContract'

type State = {
  eligible: boolean
  ratingExpiration: string | null
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  eligible: false,
  ratingExpiration: null,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CHECK_LABORER_SURVAY_ELIGIBILITY_ASYNC,
    Actions.CHECK_LABORER_SURVAY_ELIGIBILITY_SUCCESS,
    Actions.CHECK_LABORER_SURVAY_ELIGIBILITY_FAIL,
    CheckLaborerSurveyEligibilityResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CHECK_LABORER_SURVAY_ELIGIBILITY_ASYNC:
    case Actions.CHECK_LABORER_SURVAY_ELIGIBILITY_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.CHECK_LABORER_SURVAY_ELIGIBILITY_SUCCESS: {
      return {
        ...state,
        ...action.status,
        eligible: action.payload.eligible,
        ratingExpiration: action.payload.rating_expiration,
      }
    }
    default:
      return state
  }
}
